import React from 'react'
import {
    Typography,
    Paper, Divider, Grid, Button
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { PropTypes } from 'prop-types'

import KeyboardArrowRightRoundedIcon from '@material-ui/icons/KeyboardArrowRightRounded';
import BeenhereOutlinedIcon from '@material-ui/icons/BeenhereOutlined';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: 10,
        textAlign: 'center',
        height: '100%'
    },

    logoDiv: {
        border: '1px solid lightgray',
        display: 'flex',
        borderRadius: '5px',
        boxShadow: '2px 2px 2px darkgrey',
        margin: 8
    },
    image: {
        width: 90,
        height: 90,
        padding: 5
    },
    bottomSection: {
        borderTop: '1px solid lightgray',
        paddingTop: '8px',
        display: 'flex',
        marginTop: '5px',
    }

}));

function ProductComp(props) {
    const { className, name, info, release, logo, ...rest } = props
    const classes = useStyles(props);
    return (

        <>
            <Paper
                className={classes.root}
                {...rest}
            >
                <div className={classes.logoDiv}>
                    <img className={classes.image}
                        src={logo}
                        alt="Logo" />
                </div>
                <Typography gutterBottom variant="h4"  >
                    {name}
                </Typography>

                <Typography gutterBottom variant="h6">
                    {info}
                </Typography>

                <Grid container className={classes.bottomSection}>
                    <Grid item xs={6} align="left" style={{ display: 'flex' }}>
                        <BeenhereOutlinedIcon />
                        <Typography gutterBottom variant="body1">
                            {release}
                        </Typography>
                    </Grid>
                    <Grid item xs={6} align="right">
                        <Button variant="outlined" color="primary" size="small">
                            <KeyboardArrowRightRoundedIcon /> More Details
                            </Button>
                    </Grid>
                </Grid>
            </Paper>
        </>
    )
}

export default ProductComp
ProductComp.propTypes = {
    className: PropTypes.string,
    name: PropTypes.string.isRequired,
    info: PropTypes.string.isRequired,
    release: PropTypes.string.isRequired,
    logo: PropTypes.string.isRequired,
}
